(function(){
  if(window.__tsumeProductHoldGuardLoaded)return;
  window.__tsumeProductHoldGuardLoaded=true;

  var POLL_MS=15000;
  var state='available';
  var gates=[];
  var productMetaPromise=null;

  function findGates(){gates=Array.prototype.slice.call(document.querySelectorAll('[data-tsume-product-gate]'));return gates}
  function primaryGate(){return gates[0]||null}
  function formatNumber(value){return new Intl.NumberFormat('ja-JP').format(Number(value)||0)}

  function setBodyState(next){
    state=next;
    document.body.classList.toggle('tsume-product-hold-checking',next==='checking');
    document.body.classList.toggle('tsume-product-held',next==='held');
  }

  function setButtonsBlocked(blocked){
    var buttons=document.querySelectorAll('product-form button[type="submit"], product-form [name="add"], .shopify-payment-button__button');
    buttons.forEach(function(btn){
      if(blocked){if(!btn.disabled){btn.dataset.tsumeHoldDisabled='1';btn.disabled=true}}
      else if(btn.dataset.tsumeHoldDisabled==='1'){btn.disabled=false;delete btn.dataset.tsumeHoldDisabled}
    });
    document.querySelectorAll('.shopify-payment-button').forEach(function(el){
      if(blocked){el.dataset.tsumeHoldBlocked='1';el.style.pointerEvents='none';el.setAttribute('aria-disabled','true')}
      else if(el.dataset.tsumeHoldBlocked==='1'){el.style.pointerEvents='';el.removeAttribute('aria-disabled');delete el.dataset.tsumeHoldBlocked}
    });
  }

  function hideOffers(){gates.forEach(function(gate){gate.hidden=true})}

  function showEligibleOffer(campaign,isPants,price){
    gates.forEach(function(gate){
      gate.hidden=false;
      gate.classList.remove('is-held');
      var title=gate.querySelector('[data-tsume-gate-title]');
      var copy=gate.querySelector('[data-tsume-gate-copy]');
      var link=gate.querySelector('[data-tsume-offer-link]');
      if(title)title.textContent='詰め込みチャレンジ対象。';
      if(copy){
        if(isPants&&price>Number(campaign.maxPrice||0)){
          copy.hidden=false;
          copy.textContent='パンツ上限UP｜'+formatNumber(campaign.pantsMaxPrice||7980)+'円まで対象';
        }else{copy.hidden=true;copy.textContent=''}
      }
      if(link)link.textContent=String(campaign.baseCount)+'点'+formatNumber(campaign.baseTotal)+'円で詰める';
    });
  }

  function showHeld(){
    gates.forEach(function(gate){
      gate.hidden=false;gate.classList.add('is-held');
      var title=gate.querySelector('[data-tsume-gate-title]');
      var copy=gate.querySelector('[data-tsume-gate-copy]');
      if(title)title.textContent='この商品は現在、詰め込みチャレンジで一時キープ中です';
      if(copy){copy.hidden=false;copy.textContent='キープが解除されると、1点での通常購入もできます。'}
    });
  }

  function fetchJson(url){return fetch(url,{method:'GET',headers:{Accept:'application/json'}}).then(function(res){if(!res.ok)throw new Error('HTTP_'+res.status);return res.json()})}

  function productMeta(){
    if(productMetaPromise)return productMetaPromise;
    var path=window.location.pathname.replace(/\/$/,'');
    if(path.indexOf('/products/')!==0)return Promise.resolve({isPants:false});
    productMetaPromise=fetchJson(path+'.js').then(function(product){
      var tags=Array.isArray(product&&product.tags)?product.tags.map(String):[];
      return {isPants:tags.indexOf('パンツ')!==-1};
    }).catch(function(){return {isPants:false}});
    return productMetaPromise;
  }

  function check(){
    findGates();
    var gate=primaryGate();
    if(!gate)return Promise.resolve();
    var variantId=gate.dataset.variantId||'';
    var statusUrl=gate.dataset.statusUrl||'';
    var price=Number(gate.dataset.priceJpy)||0;
    if(!variantId||!statusUrl){hideOffers();setBodyState('available');setButtonsBlocked(false);return Promise.resolve()}

    setBodyState('checking');setButtonsBlocked(true);
    var configPromise=fetchJson(statusUrl+'?action=config').catch(function(){return null});
    var statusPromise=fetchJson(statusUrl+'?action=status&variantId='+encodeURIComponent(variantId));

    return Promise.all([configPromise,statusPromise,productMeta()]).then(function(results){
      var configData=results[0];
      var statusData=results[1];
      var meta=results[2]||{isPants:false};
      var campaign=configData&&configData.campaign?configData.campaign:null;
      if(statusData&&statusData.held===true){showHeld();setBodyState('held');setButtonsBlocked(true);return}
      var max=meta.isPants?Number(campaign&&campaign.pantsMaxPrice||7980):Number(campaign&&campaign.maxPrice||0);
      var eligible=!!(campaign&&campaign.active===true&&price>0&&price<=max);
      if(eligible)showEligibleOffer(campaign,meta.isPants,price);else hideOffers();
      setBodyState('available');setButtonsBlocked(false);
    }).catch(function(){hideOffers();setBodyState('checking');setButtonsBlocked(true)});
  }

  function blockIfNeeded(event){
    if(state==='available')return;
    var form=event.target&&event.target.closest?event.target.closest('form[action*="/cart/add"]'):null;
    var clickTarget=event.target&&event.target.closest?event.target.closest('[name="add"], .shopify-payment-button, .shopify-payment-button__button, [id^="sticky-cart-btn-"]'):null;
    if(form||clickTarget){event.preventDefault();event.stopImmediatePropagation()}
  }

  document.addEventListener('submit',blockIfNeeded,true);
  document.addEventListener('click',blockIfNeeded,true);
  function boot(){findGates();if(!gates.length)return;check();setInterval(function(){if(!document.hidden)check()},POLL_MS)}
  document.addEventListener('visibilitychange',function(){if(!document.hidden&&document.querySelector('[data-tsume-product-gate]'))check()});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
